import { createStyles, makeStyles } from '@material-ui/core/styles';

import { colors } from '../../styles';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    container: {
      height: '100vh',
      overflowY: 'scroll',
      overflowX: 'hidden',
      maxWidth: 'initial',
    },
    root: {
      display: 'flex',
      [theme.breakpoints.down('768')]: {
        display: 'block',
      },
    },
    headerMobile: {
      width: '100%',
      height: '8vh',
      backgroundColor: colors.greyBrand,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginBottom: '2vh',
    },
    toggleButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#greyBrand',
      color: colors.white,
      fontSize: '15px',
      height: '5vh',
      textAlign: 'center',
      marginLeft: '3vw',
      width: '8vw',
      [theme.breakpoints.down('768')]: {
        display: 'block',
      },
    },
    toggleIcon: {
      alignItems: 'center',
      backgroundColor: '#greyBrand',
      color: colors.white,
      display: 'none',
      fontSize: '15px',
      height: '5vh',
      justifyContent: 'center',
      textAlign: 'center',
      marginLeft: '3vw',
      width: '5vh',
      [theme.breakpoints.down('768')]: {
        display: 'block',
      },
    },
    senslaLogo: {
      marginLeft: '35%',
      width: '30%',
      position: 'absolute',
      left: 'auto',
      right: 'auto',
    },
    senslaLogoShort: {
      display: 'flex',
      width: '90%',
      justifyContent: 'center',
    },
  })
);
